import React, { useState, useEffect, useRef } from 'react';
import './Registration.css';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import axios from "../../../axiosInstance.js";
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';
import { Alert, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Modal from '../../../Component/CompanyAdmin/Location1/Modal';
import { Helmet } from 'react-helmet-async';
import { ClipLoader } from 'react-spinners';

import checksuccess from '../../../Assets/checksuccess.png'
import SuccessIcon from '../../../Component/Vendors/FirstAppearComponent/CaseFirstCard/SuccessIcon';
import BottomNavigationBar from '../../../Component/Customers/BottomNavigationBar';
import LocationSearchPanel from '../../../Component/CompanyAdmin/Location1/LocationSearchPanel';
import VehiclePanel from './VehiclePanel';
import ConfirmedRide from './ConfirmedRide';
import LookingForAccptance from './LookingForAcceptance';
import WaitForVehicleCome from './WaitForVehicleCome';
import MapForVendorDistance from '../Map/MapForVendorDistance';
import Loading from '../../../Component/Customers/Cards/Loading';
import AddNewData from '../../../Component/Customers/Cards/AddNewData';
import VehicleImagePanel from './VehicleImagePanel';


import leftArrow from "../../../Assets/navbar/left-arrow.png";

import img1 from '../../../Assets/add/img1.png'
import icon2 from '../../../Assets/add/icon2.svg'
import icon1 from '../../../Assets/add/icon1.svg'
import icon4 from '../../../Assets/add/icon4.svg'
import icon5 from '../../../Assets/add/icon5.svg'
import search from '../../../Assets/add/search.svg'

import icon3 from '../../../Assets/add/icon3.svg'
import rightarrow from '../../../Assets/navbar/right-arrow.svg'
import img2 from '../../../Assets/add/img2.png'
import img3 from '../../../Assets/add/img3.png'
import img4 from '../../../Assets/add/img4.png'
import img5 from '../../../Assets/add/img5.png'
import img6 from '../../../Assets/add/img6.png'
import img7 from '../../../Assets/add/img7.png'
import HomeIcon from '@mui/icons-material/Home';
import Person2Icon from '@mui/icons-material/Person2';
import img1profile from '../../../Assets/profile/img1.png'

import AddIcon from '@mui/icons-material/Add';
import MapComponent from '../../../Component/CompanyAdmin/MapComponent/MapComponent';
import TestMap from '../Map/TestMap';
import TestMapLoader from '../Map/TestMapLoader';
import ContactingServiceCard from './ContactingServiceCard';
import logo from '../../../Assets/navbar/logo.svg'
import SelectOnMap from '../../../Component/Customers/Registration/SelectOnMap';
import rightArrow from '../../../Assets/navbar/right-arrow.svg';
import frontLeft from '../../../Assets/crane/front-left.jpg'
import frontRight from '../../../Assets/crane/front-right.jpg'
import rearLeft from '../../../Assets/crane/rear-left.jpg'
import rearRight from '../../../Assets/crane/rear-right.jpg'



import mediumCraneImage from '../../../Assets/crane/mediumCrane.jpg'
import mediumRecoveryVanImage from '../../../Assets/crane/mediumRecoveryVan.jpg'

import mediumFlatbedImage from '../../../Assets/crane/mediumFlatbed.jpg'
import { State, City } from "country-state-city";



import {
    ShieldCheck, UserCheck, FileText, Truck, Box, Calendar, Shield, X, User, Trash
} from "lucide-react";

const steps = [
    { id: "01", title: "Accident Detail" },
    { id: "02", title: "Upload Image" },
    { id: "03", title: "Add Details" },
    { id: "04", title: "Map" },
    { id: "05", title: "Confirm Information" },

];
    const stepToPath = {
        "01": "select-location",
        "02": "add-images",
        "03": "choose-vehicle",
        "04": "review-submit",
        "05": "confirmation",
    };

    const pathToStep = {
        "select-location": "01",
        "add-images": "02",
        "choose-vehicle": "03",
        "review-submit": "04",
        "confirmation": "05",
    };

function AddVehicles({ item, fromPageHere, centerHere, vehicleNo }) {
    const { state } = useLocation();
    const navigate = useNavigate();
    const location = useLocation();

     const [currentStep, setCurrentStep] = useState(() => {
        if (state?.resumeAccidentVehicleCode) return '05';
        const subPath = location.pathname?.split('/')[2];
        return pathToStep[subPath] || '01';
    });
    const [startLoader, setStartLoader] = useState(false);
    const [isModalOpenLooking, setIsModalOpenLooking] = useState(false);
    const [isModalOpenQuantity, setIsModalOpenQuantity] = useState(false);
    const [isLoadingPlaces, setIsLoadingPlaces] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const [regNo, setRegNo] = useState('');
    const [vehicleInfo, setVehicleInfo] = useState([]);
    const [comingVehicleInfo, setComingVehicleInfo] = useState([]);
    const [comingVehicle, setComingVehicle] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility
    const [getData, setGetData] = useState({});
    const [showPopup, setShowPopup] = useState(true);
    const [isVerified, setIsVerified] = useState(false);
    const [comingFrom, setComingFrom] = useState('')
    const [showImageDiv, setShowImageDiv] = useState(false)
    const [isMaterialLoaded, setIsMaterialLoaded] = useState(item?.isMaterialLoaded || false);
    const [quantity, setQuantity] = useState(item?.quantity || null)

    fromPageHere = fromPageHere ? fromPageHere : ""
    const [budget, setBudget] = useState(item?.budget || '')
    const [longitude, setLongitude] = useState(item?.longitude || '')
    const [latitude, setLatitude] = useState(item?.latitude || '')

    const [dropLatitude, setDropLatitude] = useState('')
    const [dropLongitude, setDropLongitude] = useState('')

    const [pickupLocation, setPickupLocation] = useState(null)
    const [dropLocation, setDropLocation] = useState(null)

    const [destinationLocation, setDestinationLocation] = useState('')
    const [activeField, setActiveField] = useState(null)

    const [panelOpen, setPanelOpen] = useState(false)
    const [vehiclePanel, setVehiclePanel] = useState(false)
    const [confirmVehicle, setConfirmVehicle] = useState(false)

    const [doneFetching, setDoneFetching] = useState(false)
    const [selectedCrane, setSelectedCrane] = useState(false);
    const [selectedRecoveryVan, setSelectedRecoveryVan] = useState(false);
    const [selectedBoth, setSelectedBoth] = useState(false);

    const [vehicleFound, setVehicleFound] = useState(false)
    const [vehicleImagesPanel, setVehicleImagesPanel] = useState(false);

    const [vehicleType, setVehicleType] = useState(null)
    const [selectedVehicleData, setSelectedVehicleData] = useState([]);
    const [selectedFlatbed, setSelectedFlatbed] = useState(false);
    const [selectedNonFlatbed, setSelectedNonFlatbed] = useState(false);
    const [images, setImages] = useState({})

    const [onSpotName, setOnSpotName] = useState(item?.onSpotName || getData?.contactPerson || '')
    const [onSpotContact, setOnSpotContact] = useState(item?.onSpotContact || getData?.CustomerPhone || '')
    const [fullAddress, setFullAddress] = useState(item?.fullAddress || "");
    const [pincode, setPincode] = useState(item?.pincode || "");
    const [district, setDistrict] = useState(item?.district || "");
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState(item?.states || "");
    const [pin, setPin] = useState("");
    const [cities, setCities] = useState([]);
    const [isLoadingCities, setIsLoadingCities] = useState(true);
    const [isLoadingStates, setIsLoadingStates] = useState(true);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRecoveryVan, setIsRecoveryVan] = useState(item?.isRecoveryVan || false);
    const [successDone, setSuccessDone] = useState(false);
    const [accidentVehicleCode, setAccidentVehicleCode] = useState(null);
    const [trackRepeatedRequests, setTrackRepeatedRequests] = useState(null);

    const [pickupSuggestions, setPickupSuggestions] = useState([])
    const [destinationSuggestions, setDestinationSuggestions] = useState([])
    let [accidentDataObject, setAccidentDataObject] = useState({})
    const [locationData, setLocationData] = useState(null);
    const [minEstimatedAmount, setMinEstimatedAmount] = useState(null)
    const [maxEstimatedAmount, setMaxEstimatedAmount] = useState(null)
    const [minEstimatedDuration, setMinEstimatedDuration] = useState(null)
    const [maxEstimatedDuration, setMaxEstimatedDuration] = useState(null)
    const [miniCrane, setMiniCrane] = useState(null)
    const [mediumCrane, setMediumCrane] = useState(null)
    const [largeCrane, setLargeCrane] = useState(null)
    const [miniRecoveryVan, setMiniRecoveryVan] = useState(null)
    const [mediumRecoveryVan, setMediumRecoveryVan] = useState(null)
    const [largeRecoveryVan, setLargeRecoveryVan] = useState(null)
    const [distance, setDistance] = useState(null)
    const [getDistance, setGetDistance] = useState(false)
    const [isModalLast, setIsModalLast] = useState(false);
    const [isModalWaiting, setIsModalWaiting] = useState(false);
    const [chooseFromSelectedServiceFinal, setChooseFromSelectedServiceFinal] = useState(null)
    const [unloadWeight, setUnloadWeight] = useState(3)

    const [vendorData, setVendorData] = useState([]);
    const [incomingAccidentCode, setIncomingAccidentCode] = useState(null)
    const [stats, setStats] = useState({});
    const [isModalFlatBed, setIsModalFlatBed] = useState(false);
    const [isModalQuantityFlatBed, setIsModalQuantityFlatBed] = useState(false);
    const [flatOption, setFlatOption] = useState(null);
    const [nowReadOnly, setNowReadOnly] = useState(true);
    const [photoPreviews, setPhotoPreviews] = useState({
        MajorDamages1: item?.MajorDamages1 || null,
        MajorDamages2: item?.MajorDamages2 || null,
        MajorDamages3: item?.MajorDamages3 || null,
        MajorDamages4: item?.MajorDamages4 || null,
        MajorDamages5: item?.MajorDamages5 || null
    });

    const [photos, setPhotos] = useState({
        MajorDamages1: item?.MajorDamages1 || null,
        MajorDamages2: item?.MajorDamages2 || null,
        MajorDamages3: item?.MajorDamages3 || null,
        MajorDamages4: item?.MajorDamages4 || null,
        MajorDamages5: item?.MajorDamages5 || null
    });
    const [expandedImage, setExpandedImage] = useState(null);

    const panelRef = useRef(null)
    const vehiclePanelRef = useRef(null)
    const confirmVehicleRef = useRef(null)
    const vehicleFoundRef = useRef(null)
    const vehicleImagesPanelRef = useRef(null)

    useEffect(() => {
        if (getData?.contactPerson) {
            setOnSpotName(getData?.contactPerson)
        }
        if (getData?.CustomerPhone) {
            setOnSpotContact(getData?.CustomerPhone)
        }
    }, [getData])

    useEffect(() => {
        vehicleType === 'craneandrecoveryvan' ? setIsRecoveryVan(true) : setIsRecoveryVan(false);
        (quantity != "" && Number(quantity) !== 0) ? setIsMaterialLoaded(true) : setIsMaterialLoaded(false);
    }, [vehicleType, quantity])


    useEffect(() => {
        if (vehicleInfo.length !== 0) {
            setComingVehicleInfo([vehicleInfo[0].data]);
        }
    }, [vehicleInfo]);

    useEffect(() => {
        if (item !== undefined && item !== null) setIsVerified(true)
        const storedRegNo = localStorage.getItem('regNo');
        if (storedRegNo) {
            setRegNo(storedRegNo);
        }
        if (localStorage.getItem('isVerified') === 'true') {
            setIsVerified(true)
        }
    }, [token, userId, navigate]);

    const findUserById = async (id) => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/findByIdCustomer/${id}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
        response.data.data = response.data.data.filter((individualResponse) => {
            if (individualResponse.latitude !== null && individualResponse.longitude !== null) {
                individualResponse.latitude = null;
                individualResponse.longitude = null;
                return true;
            }
            return false;
        })
        setGetData(response.data.data[0])
    }

    const handleChange = (event, selectedVehicle) => {
        setRegNo(event.target.value);
        let option = selectedVehicle.availableOptions.length ? selectedVehicle.availableOptions : [];
        setSelectedVehicleData(option)
    };

    const handleNext = () => {
        setIsVerified(true)
        closeModal()
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const photoRefs = {
        MajorDamages1: useRef(null),
        MajorDamages2: useRef(null),
        MajorDamages3: useRef(null),
        MajorDamages4: useRef(null),
        MajorDamages5: useRef(null)
    };
    const handleFileChange = (event, type) => {
        const file = event.target.files[0];
        if (file && file.size > 2097152) {
            setAlertInfo({ show: true, message: "File size should be less than 2 MB", severity: 'error' });
            if (photoRefs[type].current) {
                photoRefs[type].current.value = "";
            }
        } else if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setPhotos(prev => ({ ...prev, [type]: file }));
                setPhotoPreviews(prev => ({ ...prev, [type]: reader.result }));
            };
            reader.readAsDataURL(file);
        }
    };

    // ------------------------------------------------------------------
    // RESUME: explicit only. Nothing here calls the backend automatically.
    // A resume ONLY happens when the caller (e.g. the homepage's
    // "Track Recent Cases" card) navigates here with
    // state: { resumeAccidentVehicleCode, resumeService }.
    // A plain landing on /addVehicles (fresh "Get Service" click, direct
    // link, refresh) always starts at step 01 — no network check, no
    // race with what the user is typing.
    // ------------------------------------------------------------------
    useEffect(() => {
        if (state?.resumeAccidentVehicleCode) {
            setAccidentVehicleCode(state.resumeAccidentVehicleCode);
            setVehicleType(state.resumeService);
            localStorage.setItem('AccidentVehicleCode', state.resumeAccidentVehicleCode);
            localStorage.setItem('vehicleType', state.resumeService);
            localStorage.setItem('currentService', state.resumeService);
            localStorage.setItem('currentStep', '05');
            // setCurrentStep('05');
            // navigate('/addVehicles/confirmation', { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (state?.center) {
            setDropLatitude(state.center[0])
            setDropLongitude(state.center[1])
            setDropLocation(state.placeName)
            setIsVerified(true)
        }
        if (state?.fromPageHere) {
            setComingFrom(state.fromPageHere)
        }

        if (latitude && longitude && dropLatitude && dropLongitude) {
            const getNearByVendor = async () => {
                try {
                    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/findNearbyLocation/${userId}`, {
                        pickuplatitude: latitude,
                        pickuplongitude: longitude,
                        dropLatitude: dropLatitude,
                        dropLongitude: dropLongitude,
                        selectedVendor: 'crane'
                    }, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    if (response.status === 200) {
                        setAlertInfo({ show: true, message: "get vendor!!!", severity: 'success' });
                    } else {
                        setAlertInfo({ show: true, message: "failed to get Vendor", severity: 'error' });
                    }
                }
                catch (error) {
                    console.error("Error uploading photos:", error);
                    const errorMessage = error.response?.data?.message || 'An error occurred';
                    if (errorMessage === "jwt expired") {
                        setAlertInfo({ show: true, message: "Your session has expired. Redirecting to login...", severity: 'error' });
                        setTimeout(() => {
                            window.location.href = '/';
                        }, 2000);
                    } else {
                        setAlertInfo({ show: true, message: "An error occurred while uploading photos.", severity: 'error' });
                    }
                }
            }
            getNearByVendor()
        }
    }, [state]);

    useEffect(() => {
        if (centerHere) {
            setDropLatitude(centerHere[0])
            setDropLongitude(centerHere[1])
            setIsVerified(true)
        }
    }, [centerHere]);

    useEffect(() => {
        loadStates();
    }, []);

    const loadStates = () => {
        setIsLoadingStates(true);
        try {
            const allStates = State.getStatesOfCountry("IN");
            setStates(allStates);
        } catch (error) {
            console.error("Error loading states:", error);
            setStates([]);
        } finally {
            setIsLoadingStates(false);
        }
    };

    const loadCities = (stateCode) => {
        setIsLoadingCities(true);
        try {
            const allCities = City.getCitiesOfState("IN", stateCode);
            setCities(allCities);
        } catch (error) {
            console.error("Error loading cities:", error);
            setCities([]);
        } finally {
            setIsLoadingCities(false);
        }
    };

    useEffect(() => {
        if (selectedState) {
            setCities([]);
            setDistrict('');
            setPincode('');
            loadCities(selectedState);
        } else {
            setCities([]);
        }
    }, [selectedState]);

    const fullAddress1 = `${fullAddress}, ${district},${pin}, ${selectedState}`;

    let finalSelectedService = 'crane';

    const handleLocationChange = (data) => {
        setLocationData(data);
    };

    // Only ever consumes fresh location data from the map picker (step 01).
    // No resume/poll logic lives here anymore — see the resume effect above.
    useEffect(() => {
        if (locationData) {
            setLatitude(locationData.latitude || '');
            setLongitude(locationData.longitude || '');
            setPickupLocation(locationData.pickupLocation || '');
            setDropLocation(locationData.dropLocation || '');
            setDropLatitude(locationData.dropLatitude || '');
            setDropLongitude(locationData.dropLongitude || '');
        }
    }, [locationData]);

    useEffect(() => {
        let fdata = JSON.parse(localStorage.getItem('formData') || '[]')

        let pickupLoc = localStorage.getItem('pickupLoc')
        let lat = parseFloat(localStorage.getItem('pickLatitude'))
        let lon = parseFloat(localStorage.getItem('pickLongitude'))

        let dropLoc = localStorage.getItem('dropLoc')
        let dropLatitude = parseFloat(localStorage.getItem('dropLatitude'))
        let dropLongitude = parseFloat(localStorage.getItem('dropLongitude'))

        let userId = localStorage.getItem('userId')

        setAccidentDataObject(prev => ({
            ...prev,
            regNo: fdata.vehicleNo,
            fullAddress,
            district,
            pincode,
            onSpotContact: fdata.driverNumber,
            onSpotName: fdata.driverName,
            isRecoveryVan,
            isMaterialLoaded,
            quantity,
            budget,
            ...images,
            latitude: lat,
            longitude: lon,
            pickupLocation: pickupLoc,
            dropLocation: dropLoc,
            dropLatitude: dropLatitude,
            dropLongitude: dropLongitude,
            selectedOptions: vehicleType,
            CustomerCode: userId
        }));
    }, [
        regNo,
        fullAddress,
        pincode,
        onSpotContact,
        onSpotName,
        isRecoveryVan,
        isMaterialLoaded,
        quantity,
        budget,
        photos,
        comingVehicle,
        getData,
        images,
        vehicleType,
        latitude,
        dropLatitude,
        longitude,
        dropLongitude
    ]);

    const handleSubmit = async (e) => {
        setMinEstimatedAmount(accidentDataObject.minAmount)
        setMaxEstimatedAmount(accidentDataObject.maxAmount)
        setMinEstimatedDuration(accidentDataObject.minDuration)
        setMaxEstimatedDuration(accidentDataObject.maxDuration)

        localStorage.setItem('minDuration', accidentDataObject.minDuration)
        localStorage.setItem('maxDuration', accidentDataObject.maxDuration)
        localStorage.setItem('maxAmount', accidentDataObject.maxAmount.toFixed(2))

        const { vendorData, ...rest } = accidentDataObject;
        localStorage.setItem('accidentDataObject', JSON.stringify(rest));
        const formDataObj = new FormData();
        for (const key in accidentDataObject) {
            if (accidentDataObject[key]) {
                if (accidentDataObject[key] instanceof File) {
                    formDataObj.append(key, accidentDataObject[key], accidentDataObject[key].name);
                } else {
                    formDataObj.append(key, accidentDataObject[key]);
                }
            }
        }
        formDataObj.append('trackRepeatedRequests', trackRepeatedRequests);
        formDataObj.append('AccidentVehicleCode', accidentVehicleCode);

        try {
            setIsLoading(true);
            const response = await axios({
                method: 'POST',
                url: `${process.env.REACT_APP_BACKEND_URL}/addAccidentDetails/${userId}`,
                data: formDataObj,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            setIsModalWaiting(true)

            if (response.status == 200) {
                setSuccessDone(true)
                setConfirmVehicle(false);
                setVehicleFound(true);
                setIsVerified(false)
                setLatitude(null)
                setLongitude(null)
                setAccidentVehicleCode(response.data.AccidentVehicleCode)
                setTrackRepeatedRequests(response.data.trackRepeatedRequests)
                localStorage.setItem("isVerified", 'false')
                localStorage.setItem('regNo', '');
                localStorage.setItem('currentStep', '05')
                localStorage.setItem('AccidentVehicleCode', response.data.AccidentVehicleCode)
                setCurrentStep("05")
                setAlertInfo({ show: true, message: "Data Successfully Added!!!", severity: 'success' });
            }

        } catch (error) {
            setIsLoading(false);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            if (errorMessage === "jwt expired") {
                setAlertInfo({ show: true, message: "Your session has expired. Redirecting to login...", severity: 'error' });
                setTimeout(() => {
                    window.location.href = '/';
                }, 2000);
            } else {
                setAlertInfo({ show: true, message: errorMessage, severity: 'error' });
            }
        } finally {
            setIsLoading(false);
        }
    };


    useGSAP(function () {
        if (panelOpen) {
            gsap.to(panelRef.current, {
                height: '100%',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut'
            })
        }
        if (!panelOpen) {
            gsap.to(panelRef.current, {
                height: '0%',
                opacity: 0,
            })
        }
    }, [panelOpen])

    useGSAP(function () {
        if (vehiclePanel) {
            gsap.to(vehiclePanelRef.current, {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut',
                zIndex: '1001',
                boxShadow: 'inset -1px -6px 20px 0px #020202',
                height: '300px',
                overflowY: 'auto'
            });
        } else {
            gsap.to(vehiclePanelRef.current, {
                transform: 'translateY(100%)',
                opacity: 0,
                duration: 0,
                zIndex: '1001',
            });
        }
    }, [vehiclePanel]);

    useGSAP(function () {
        if (vehicleImagesPanel) {
            gsap.to(vehicleImagesPanelRef.current, {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut',
                zIndex: '1001',
                boxShadow: 'inset -1px -6px 20px 0px #020202',
                height: '400px',
                overflowY: 'auto'
            });
        } else {
            gsap.to(vehicleImagesPanelRef.current, {
                transform: 'translateY(100%)',
                opacity: 0,
                duration: 0,
                zIndex: '1000',
                height: '0px'
            });
        }
    }, [vehicleImagesPanel]);

    useGSAP(function () {
        if (confirmVehicle) {
            gsap.to(confirmVehicleRef.current, {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut',
                zIndex: '1001',
                boxShadow: 'inset -1px -6px 20px 0px #020202',
                height: '95vh',
                overflowY: 'auto'
            });
        } else {
            gsap.to(confirmVehicleRef.current, {
                transform: 'translateY(100%)',
                opacity: 0,
                duration: 1,
                ease: 'power-3.inOut',
                width: '100%',
                zIndex: '1000',
            });
        }
    }, [confirmVehicle]);


    useGSAP(async function () {
        if (vehicleFound) {
            gsap.to(vehicleFoundRef.current, {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut',
                width: '100%',
                height: "95vh",
                zIndex: '1001',
                overflowY: 'auto'
            })
        }
        else {
            gsap.to(vehicleFoundRef.current, {
                transform: 'translateY(100%)',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut',
                padding: '0px',
                height: "0vh",
                zIndex: '1001',
                padding: '20px'
            })
        }
    }, [vehicleFound])

    useEffect(() => {
        if (fromPageHere !== "allvehicles") setNowReadOnly(false)
    }, [fromPageHere])

    function findTrip() {
        setPanelOpen(false)
        setVehiclePanel(true)
    }

    const navigateTo = () => {
    }

    const stepRef = useRef(null);



    // currentStep is the single source of truth; this just keeps the URL in
    // sync with it (one direction only — never the other way around, so
    // there's no ping-pong between this and the pathname-reading effect below).
    useEffect(() => {
        const newPath = stepToPath[currentStep];
        if (newPath && !location.pathname.endsWith(`/${newPath}`)) {
            navigate(`/addVehicles/${newPath}`, { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep]);

    // Reads the URL only to support direct links / browser back-forward
    // between steps already visited in this session. Never redirects on its
    // own and never fires a backend call — deliberately inert on a bare
    // "/addVehicles" landing so it can't race the mount-time resume effect
    // or interrupt someone actively filling out the form.
    useEffect(() => {
        const pathParts = location.pathname?.split("/");
        const subPath = pathParts?.[2];
        if (!subPath) return;
        const step = pathToStep[subPath] || "01";
        setCurrentStep(step);
    }, [location.pathname]);


    const prevStep = (step) => {
        const path = stepToPath[step];
        if (step === currentStep || !path) return;
        if (path) {
            navigate(`/addVehicles/${path}`);
        }
    };


    const gotToCraneDashboardQuotationUpdate = () => {
        navigateTo('/crane-dashboard/quotationupdate')
    }

    const MAX_SIZE_MB = 1;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;


    const handleImageChange = async (key, file) => {
        if (!file) return;

        try {
            setStartLoader(true);
            const compressedFile = await compressImage(file);

            if (compressedFile.size > MAX_SIZE_BYTES) {
                alert('Image should be less than 1 MB.');
                return;
            }

            const storedVehicleDetails = localStorage.getItem('formData');
            const { vehicleNo, driverName, driverNumber } = JSON.parse(storedVehicleDetails);
            const formData = new FormData();
            formData.append(key, compressedFile);
            formData.append('pickupLocation', localStorage.getItem("pickupLoc") || '');
            formData.append('dropLocation', localStorage.getItem("dropLoc") || '');
            formData.append('latitude', localStorage.getItem("pickLatitude") || '');
            formData.append('longitude', localStorage.getItem("pickLongitude") || '');
            formData.append('dropLatitude', localStorage.getItem("dropLatitude") || '');
            formData.append('dropLongitude', localStorage.getItem("dropLongitude") || '');
            formData.append('regNo', vehicleNo || '');
            formData.append('onSpotContact', driverNumber || '');
            formData.append('onSpotName', driverName || '');
            formData.append(
                'AccidentVehicleCode',
                accidentVehicleCode == null ? '' : accidentVehicleCode
            );

            const reader = new FileReader();
            reader.onloadend = async () => {
                const base64 = reader.result;
                const storedImages = JSON.parse(localStorage.getItem("storedImages") || "{}");
                storedImages[key] = base64;
                localStorage.setItem("storedImages", JSON.stringify(storedImages));

                try {
                    const res = await axios.put(
                        `${process.env.REACT_APP_BACKEND_URL}/api/saveInitialAccidentData/${userId}`,
                        formData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );

                    if (res.status === 200) {
                        setStartLoader(false)
                        setImages((prev) => ({ ...prev, [key]: res.data[key] }));
                        setAccidentVehicleCode(res.data.AccidentVehicleCode)
                    }
                } catch (uploadError) {
                    setStartLoader(false)
                    console.error("Image upload error:", uploadError);
                    alert("Failed to upload image.");
                }
            };
            reader.readAsDataURL(compressedFile);

        } catch (error) {
            console.error("Image processing error:", error);
            alert("Failed to process image.");
        }
    };

    const base64ToFile = (base64, filename) => {
        const [header, data] = base64.split(',');
        const mimeMatch = header.match(/:(.*?);/);
        const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
        const binary = atob(data);
        const array = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            array[i] = binary.charCodeAt(i);
        }
        return new File([array], filename, { type: mime });
    };


    useEffect(() => {
        const loadStoredImages = async () => {
            const storedImages = JSON.parse(localStorage.getItem("storedImages") || "{}");
            const restoredImages = {};

            for (const key of Object.keys(storedImages)) {
            try {
                restoredImages[key] = base64ToFile(storedImages[key], `${key}.jpg`);
            } catch (err) {
                console.error(`Failed to restore image ${key}:`, err);
            }
        }
        setImages(restoredImages);
    };

        const storedVehicleType = localStorage.getItem('vehicleType');
        const storedService = localStorage.getItem('currentService');
        const storedFlatbedOption = localStorage.getItem('flatbedOption');

        setVehicleType(storedVehicleType);

        if (storedVehicleType === 'crane') {
            setSelectedCrane(true);
            setSelectedRecoveryVan(false);
            setSelectedNonFlatbed(false);
            setSelectedFlatbed(false);
            setSelectedBoth(false);
        } else if (storedVehicleType === 'recoveryVan') {
            setSelectedCrane(false);
            setSelectedRecoveryVan(true);
            setSelectedBoth(false);

            if (storedFlatbedOption === 'Flat-bed') {
                setSelectedFlatbed(true);
                setSelectedNonFlatbed(false);
                setFlatOption('Flat-bed');
            } else if (storedFlatbedOption === 'Non-flat-bed') {
                setSelectedNonFlatbed(true);
                setSelectedFlatbed(false);
                setFlatOption('Non-flat-bed');
            }
        }

        loadStoredImages();
    }, []);


    const compressImage = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    const scale = Math.min(800 / img.width, 800 / img.height, 1);
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;

                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                const compressedFile = new File([blob], file.name, { type: file.type });
                                resolve(compressedFile);
                            } else {
                                reject(new Error("Compression failed"));
                            }
                        },
                        file.type,
                        0.7
                    );
                };
                img.onerror = reject;
                img.src = event.target.result;
            };

            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };



    const handleAddImageField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeys((prev) => [...prev, newKey]);
    };

    const moveThrdStage = () => {
        setIsSubmitting(false)
        setIsModalOpenQuantity(false)
        setCurrentStep('03')
        stepRef.current?.scrollIntoView({ behavior: "smooth" });
    }

    const callIsSetIsModalOpenQuantity = () => {
        setIsModalOpenQuantity(false)
        moveThrdStage()
    }

    const setLoaderStage = (e) => {
        setCurrentStep(e)
    }

    const getVendorsWithLocation = async (optionalTrackRepeatedRequest = null) => {
        setIsLoading(true);
        setGetDistance(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/findNearByVendorsToShow/${userId}`,
                {
                    pickuplatitude: accidentDataObject.latitude,
                    pickuplongitude: accidentDataObject.longitude,
                    dropLatitude: accidentDataObject.dropLatitude,
                    dropLongitude: accidentDataObject.dropLongitude,
                    selectedVendor: ['crane'],
                    quantity: accidentDataObject.quantity,
                    vehicleNo: accidentDataObject.regNo,
                    pickupLocation: pickupLocation,
                    dropLocation: dropLocation,
                    trackRepeatedRequests: optionalTrackRepeatedRequest
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const vendorDataArr = response.data?.data || [];
            const summary = response.data?.summary || {};
            setVendorData(vendorDataArr);

            const updatedStats = { ...stats };
            const allTypes = [
                'miniRecoveryVan', 'mediumRecoveryVan', 'largeRecoveryVan',
                'miniCrane', 'mediumCrane', 'largeCrane',
            ];

            allTypes.forEach((type) => {
                if (summary[type]) {
                    updatedStats[type] = {
                        minDuration: summary[type]?.minDuration || '',
                        maxDuration: summary[type]?.maxDuration || '',
                        minAmount: summary[type]?.minAmount || 0,
                        maxAmount: summary[type]?.maxAmount || 0,
                        vendorDriverIds: summary[type]?.vendorDriverId || [],
                    };
                } else {
                    updatedStats[type] = {
                        minDuration: '',
                        maxDuration: '',
                        minAmount: 0,
                        maxAmount: 0,
                        vendorDriverIds: [],
                    };
                }
            });

            setStats(updatedStats);
            setIsLoading(false);

        } catch (err) {
            console.error("Error fetching vendor data:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const getVendorsWithLocationForFlatBed = async (optionalTrackRepeatedRequest = null) => {
        setIsLoading(true);
        setGetDistance(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/findNearByVendorsToShow/${userId}`,
                {
                    pickuplatitude: accidentDataObject.latitude,
                    pickuplongitude: accidentDataObject.longitude,
                    dropLatitude: accidentDataObject.dropLatitude,
                    dropLongitude: accidentDataObject.dropLongitude,
                    selectedVendor: ['recoveryVan'],
                    chooseFromSelectedSubServiceFinal: localStorage.getItem('flatbedOption'),
                    vehicleNo: accidentDataObject.regNo,
                    pickupLocation: pickupLocation,
                    dropLocation: dropLocation,
                    trackRepeatedRequests: optionalTrackRepeatedRequest
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const vendorDataArr = response.data?.data || [];
            const summary = response.data?.summary || {};
            setVendorData(vendorDataArr);

            const updatedStats = { ...stats };
            const allTypes = [
                'miniRecoveryVan', 'mediumRecoveryVan', 'largeRecoveryVan',
                'miniCrane', 'mediumCrane', 'largeCrane',
            ];

            allTypes.forEach((type) => {
                if (summary[type]) {
                    updatedStats[type] = {
                        minDuration: summary[type]?.minDuration || '',
                        maxDuration: summary[type]?.maxDuration || '',
                        minAmount: summary[type]?.minAmount || 0,
                        maxAmount: summary[type]?.maxAmount || 0,
                        nonGSTCharge: summary[type]?.nonGSTCharge || 0,
                        vendorDriverIds: summary[type]?.vendorDriverId || [],
                    };
                } else {
                    updatedStats[type] = {
                        minDuration: '',
                        maxDuration: '',
                        minAmount: 0,
                        maxAmount: 0,
                        nonGSTCharge: 0,
                        vendorDriverIds: [],
                    };
                }
            });

            setStats(updatedStats);
        } catch (err) {
            console.error("Error fetching vendor data:", err);
        } finally {
            setIsLoading(false);
        }
    };

    // ------------------------------------------------------------------
    // Same-service conflict check: called only at the moment the user
    // tries to continue from "choose vehicle" — NOT on mount, NOT in the
    // background. Backend still enforces this at submission time as the
    // real guarantee (two tabs / slow network could both pass this).
    // ------------------------------------------------------------------
    const findActiveConflict = async (servicesToCheck) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/getActiveQuickServiceRequests/${userId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const active = response.data?.requests || [];
            return servicesToCheck
                .map(service => active.find(r => r.currentService === service))
                .find(Boolean) || null;
        } catch (err) {
            console.error('Failed to check active requests:', err);
            return null; // fail open — don't block the user if the check itself fails
        }
    };

    const handleChooseVehicleContinue = async () => {
        if (vehicleType == null) return;

        const servicesToCheck = vehicleType.split(',');
        const conflict = await findActiveConflict(servicesToCheck);

        if (conflict) {
            setAlertInfo({
                show: true,
                severity: 'error',
                message: `You already have an active ${conflict.currentService} request. Resume it from the homepage instead of starting a new one.`
            });
            return;
        }

        if (vehicleType === 'crane') {
            setIsModalOpenQuantity(true);
        }
        else if (vehicleType === 'recoveryVan' && flatOption != null) {
            getVendorsWithLocationForFlatBed();
            setCurrentStep('04');
        }
        else if (vehicleType === 'crane,recoveryVan') {
            setIsModalQuantityFlatBed(true);
        }
        else {
            getVendorsWithLocation();
            setCurrentStep('04');
        }
    };

    const [imageKeys, setImageKeys] = useState([
        "Front Right",
        "Front Left",
        "Rear Right",
        "Rear Left",
        "Additional Image 1",
        "Additional Image 2",
        "Additional Image 3",
        "Additional Image 4",
        "Additional Image 5",
        "Additional Image 6",

        ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    ])

    const placeholderImages = {
        "Front Right": frontLeft,
        "Front Left": frontRight,
        "Rear Right": rearRight,
        "Rear Left": rearLeft,
    };


    const requiredImageKeys = ["Front Right",
        "Front Left",
        "Rear Right",
        "Rear Left",
    ];

    const isContinueEnabled = requiredImageKeys.every((key) => !!images[key]);


    return (
        <>
            <div>
                {startLoader && (
                    <div className="fixed inset-0 z-[9999] bg-white bg-opacity-80 flex items-center justify-center">
                        <div className="loader2 h-[50px] w-[20px]"></div>
                    </div>
                )}

                {alertInfo.show && (
                    <div className="fixed top-[4.5rem] left-0 right-0 z-[2000] flex justify-center px-4">
                        <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                            {alertInfo.message}
                        </Alert>
                    </div>
                )}

                <div ref={stepRef} className="bg-white pt-0 px-0 md:pt-[50px] md:px-[80px]  px-[20px] min-h-screen "  >

                <div className={`fixed top-0 left-0 w-full flex items-center justify-between px-3 py-1 z-50 ${currentStep !== '01' ? `bg-white shadow-md` : ''}`}>
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png' alt="logo" className="h-[3rem] w-[3rem] object-contain" />
                    <Link to='/user-profile-details' className=' h-10 w-10 bg-white flex items-center justify-center rounded-full border shadow'>
                        <User className="text-gray-500" />
                    </Link>
                </div>
                {currentStep != "01" && (
                    <div className="hidden bg-white md:flex pt-[5rem] items-center flex-wrap justify-center gap-[10px] relative pb-[33px]">
                        {steps.map((step, index) => (
                            <div key={index} className="flex items-center relative">
                                <div className="flex flex-col justify-center items-center relative">
                                    {index !== 0 && (
                                        <div
                                            className={`absolute w-full h-1 top-4 ${currentStep > index ? "bg-blue-500" : "bg-gray-300"}`}
                                            style={{ left: "-50%", zIndex: -1 }}
                                        />
                                    )}

                                        <div
                                            className={`w-[32px] text-[#242E39] cursor-pointer bg-[#FFFFFF] h-[32px] border-[2px] flex items-center justify-center rounded-full font-bold`}
                                            style={{
                                                border: currentStep >= step.id ? '3px solid #21A6E9' : '3px solid white',
                                                boxShadow: currentStep >= step.id ? '-3px 0px 20px' : '-3px 0px 20px',
                                                borderColor: currentStep >= step?.id ? '#21A6E9' : '#A1AEBE'
                                            }}
                                            onClick={() => setCurrentStep(step?.id)}
                                        >
                                            {step?.id}
                                        </div>

                                        <p className={`mt-[10px] mb-0 md:text-[13px] text-[10px] text-center font-satoshi font-[500] ${currentStep >= step?.id ? "text-[#21A6E9]" : "text-[#A1AEBE]"
                                            }`}>
                                            {step.title}
                                        </p>
                                    </div>

                                    {index !== steps.length - 1 && (
                                        <div
                                            className={`h-[3px] w-[80px] mx-2 mb-[32px] md:block hidden ${currentStep > steps[index]?.id ? "bg-[#21A6E9]" : "bg-[#A1AEBE]"
                                                }`}
                                        ></div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}


                    {currentStep === "01" && (
                        <div>
                            <SelectOnMap onLocationChange={handleLocationChange} />
                        </div>
                    )}

                    {currentStep === "02" &&
                        <div>
                            <div className="mb-[3rem] bg-[linear-gradient(175deg,_#ffffff,_transparent)] md:bg-[#ffffff] md:w-full rounded-[30px] md:p-[78px] max-w-[1148px] mx-auto p-[20px] pt-[12%] bg-successs">

                                <div className='font-satoshi' >

                                    <div className="flex flex-col items-start my-6">
                                        <div className="flex items-start gap-3 md:-mt-[70px]">
                                            <img
                                                src="https://cdn.pixabay.com/photo/2016/01/03/00/43/upload-1118929_640.png"
                                                className="w-10 h-10 self-center"
                                                alt="Upload Icon"
                                            />
                                            <div className="flex flex-col justify-center mt-[10]" style={{ marginTop: "5px" }}>
                                                <h2 className="text-[1rem] font-semibold">UPLOAD VEHICLE IMAGES</h2>
                                                <p className="text-xs text-gray-500">Upload required vehicle images to proceed with.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="overflow-auto grid grid-cols-2 lg:grid-cols-5 gap-[0.7rem]" style={{ marginTop: "-10px" }}>
                                        {imageKeys.map((key, index) => {
                                            const showPlaceholder = index < 4;

                                            const isUploaded = Boolean(images[key]);

                                            const imageSrc = isUploaded
                                                ? (images[key] instanceof File
                                                    ? URL.createObjectURL(images[key])
                                                    : images[key]
                                                )
                                                : showPlaceholder
                                                    ? placeholderImages[key]
                                                    : null;

                                            return (
                                                <div
                                                    key={key}
                                                    className="relative rounded-xl border-2 border-dotted border-gray-400"
                                                    style={{ height: "180px" }}
                                                >
                                                    {!isUploaded && index < 4 && (
                                                        <span className="absolute top-1 right-1 text-red-700 text-2xl font-black z-30 drop-shadow-md">*</span>
                                                    )}

                                                    <div className="relative w-full h-full rounded-xl overflow-hidden">
                                                        {imageSrc && (
                                                            <img
                                                                src={imageSrc}
                                                                alt={key}
                                                                className={`w-full h-full object-contain ${!isUploaded ? "blur-smm opacity-50" : ""
                                                                    }`}
                                                            />
                                                        )}

                                                        {isUploaded && (
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setImages((prev) => {
                                                                        const newImages = { ...prev };
                                                                        delete newImages[key];

                                                                        const storedImages = JSON.parse(localStorage.getItem("storedImages") || "{}");
                                                                        delete storedImages[key];
                                                                        localStorage.setItem("storedImages", JSON.stringify(storedImages));

                                                                        setAccidentDataObject(prevAccidentData => {
                                                                            const updatedAccidentData = { ...prevAccidentData };
                                                                            delete updatedAccidentData[key];
                                                                            return updatedAccidentData;
                                                                        });

                                                                        return newImages;
                                                                    });
                                                                }}
                                                                className="absolute top-1 right-1 bg-red-300 text-white rounded-full w-8 h-8 flex items-center justify-center text-xs hover:bg-red-700 z-20"
                                                                title="Remove Image"
                                                            >
                                                                <Trash />
                                                            </button>
                                                        )}

                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                document.getElementById(`hiddenFileInput-${key}`).click()
                                                            }
                                                            className={`absolute inset-0 flex items-center justify-center z-10 ${isUploaded ? "pointer-events-none" : ""
                                                                }`}
                                                        >
                                                            {!isUploaded && (
                                                                <div className="bg-gray-700 p-2 rounded-full text-white shadow-lg hover:bg-black">
                                                                    <AddIcon />
                                                                </div>
                                                            )}
                                                        </button>

                                                        <input
                                                            type="file"
                                                            id={`hiddenFileInput-${key}`}
                                                            accept="image/*"
                                                            capture="environment"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                if (file) {
                                                                    handleImageChange(key, file);
                                                                }
                                                                e.target.value = null;
                                                            }}
                                                            style={{ display: "none" }}
                                                        />
                                                    </div>

                                                    <label className="absolute bottom-1 left-0 right-0 text-center text-xs font-semibold text-white bg-black bg-opacity-50 rounded-md mx-2 py-0.5">
                                                        {requiredImageKeys.includes(key) ? (
                                                            <>
                                                                {key.charAt(0).toUpperCase() + key.slice(1)}{' '}
                                                                <span className="contents text-red-800"></span>
                                                            </>
                                                        ) : (
                                                            key.charAt(0).toUpperCase() + key.slice(1)
                                                        )}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {Object.keys(images).length >= 6 && (
                                        <div className="flex justify-end  mb-4 px-2 py-1">
                                            <button
                                                type="button"
                                                onClick={handleAddImageField}
                                                className="px-4 py-2 bg-gray-700 text-white rounded-xl rounded-md hover:bg-gray-800"
                                            >
                                                ➕ Add
                                            </button>
                                        </div>)}

                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10]">
                                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full  gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                            <button
                                                onClick={() => { localStorage.setItem('currentStep', '01'); setCurrentStep('01') }}
                                                className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full
                                                 bg-[#EE3840] hover:bg-[#d32f2f]"
                                        >
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px] rotate-180" />
                                            Back
                                        </button>

                                            <button
                                                disabled={!isContinueEnabled}
                                                onClick={() => {
                                                    localStorage.setItem('currentStep', '03');
                                                    setCurrentStep('03');
                                                }}
                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
    ${isContinueEnabled
                                                    ? 'bg-[#21A6E9] hover:bg-[#1e94d6]'
                                                    : 'bg-[#a7dbf5] cursor-not-allowed'
                                                }`}
                                        >
                                            Continue
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                        </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {currentStep === "03" && (
                        <div className="flex md:flex-row flex-col justify-center gap-[30px]">
                            <div className="bg-[linear-gradient(175deg, #ffffff, transparent)] md:bg-[#FFFFFF] max-w-[694px] w-full  rounded-[30px] md:py-[50px] py-[30px] md:px-[40px] px-[20px]">

                                <div className='  md:bg-[#ffffff] md:w-full rounded-[2rem]  max-w-[1148px] mx-auto p-[1rem] pb-[0.5rem] pt-[1rem] '>

                                    <div className="font-satoshi flex flex-col items-start mt-6 mb-[0.5rem]">
                                        <div className="flex items-start gap-3 md:-mt-[70px]">
                                            <div className="flex flex-col justify-center mt-[10]" style={{ marginTop: "5px" }}>
                                                <h2 className="text-[1rem] font-semibold">CHOOSE SUPPORT VEHICLE</h2>
                                                <p className="text-xs text-gray-500">Please choose the service you need.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 gap-[1rem]">
                                    <div className="w-full mb-[3rem] col-span-2  rounded-[30px] md:p-[2px] p-[20px]">
                                        <div className="grid grid-cols-1  gap-[24px]">
                                            {(selectedVehicleData.length === 0 || selectedVehicleData.includes('crane')) && (
                                                <div>
                                                    <div
                                                        className={`flex flex-col items-center overflow-hidden rounded-2xl shadow-[20px_20px_20px_rgba(0,0,0,0.3)]  bg-[#f6f2f2] cursor-pointer transition-shadow duration-300 hover:shadow-2xl ${selectedCrane ? 'ring-2 ring-yellow-400' : ''}`}
                                                        onClick={() => {
                                                            const newValue = !selectedCrane;
                                                            if (newValue) {
                                                                localStorage.setItem('vehicleType', 'crane');
                                                                localStorage.setItem('currentService', 'crane');
                                                                localStorage.removeItem('flatbedOption');
                                                                setSelectedNonFlatbed(false);
                                                                setSelectedFlatbed(false);
                                                                setVehicleType('crane');
                                                            } else {
                                                                localStorage.removeItem('vehicleType');
                                                                localStorage.removeItem('currentService')
                                                                localStorage.removeItem('flatbedOption');
                                                                setSelectedNonFlatbed(false);
                                                                setSelectedFlatbed(false);
                                                                setVehicleType(null);
                                                            }

                                                        setSelectedCrane(newValue);
                                                        setSelectedRecoveryVan(false);
                                                        setSelectedBoth(false);
                                                    }}
                                                >
                                                    <div className="w-full aspect-[8/3] overflow-hidden">
                                                        <img
                                                            src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumCrane.jpg'
                                                            className="w-full h-[75%] object-contain transition-transform duration-300 hover:scale-105"
                                                            alt="Hydra Crane"
                                                        />
                                                    </div>
                                                    <h6 className="text-center font-satoshi text-sm md:text-base font-semibold mb-3">Hydra Crane</h6>
                                                </div>
                                            </div>
                                        )}

                                            {(selectedVehicleData.length === 0 || selectedVehicleData.includes('recoveryVan')) && (
                                                <div>
                                                    <div
                                                        className={`flex flex-col items-center overflow-hidden rounded-2xl shadow-[20px_20px_20px_rgba(0,0,0,0.3)]  cursor-pointer  bg-white transition-shadow duration-300 hover:shadow-2xl ${selectedNonFlatbed ? 'ring-2 ring-yellow-400' : ''}`}
                                                        onClick={() => {
                                                            const newValue = !selectedNonFlatbed;

                                                            setSelectedNonFlatbed(newValue);
                                                            setSelectedFlatbed(false);
                                                            setSelectedCrane(false);
                                                            setSelectedBoth(false);

                                                        if (newValue) {
                                                            localStorage.setItem('vehicleType', 'recoveryVan');
                                                            localStorage.setItem('currentService', 'recoveryVan');
                                                            localStorage.setItem('flatbedOption', 'Non-flat-bed');
                                                            setVehicleType('recoveryVan');
                                                            setFlatOption('Non-flat-bed');
                                                        } else {
                                                            localStorage.removeItem('vehicleType');
                                                            localStorage.removeItem('currentService');
                                                            localStorage.removeItem('flatbedOption');
                                                            setVehicleType(null);
                                                            setFlatOption(null);
                                                            setFullAddress(null);
                                                        }
                                                    }}
                                                >
                                                    <div className="w-full aspect-[8/3] overflow-hidden">
                                                        <img
                                                            src={mediumRecoveryVanImage}
                                                            className="w-full h-full object-contain transition-transform duration-300 hover:scale-105"
                                                            alt="Recovery Van"
                                                        />
                                                    </div>
                                                    <h6 className="text-center font-satoshi text-sm md:text-base font-semibold mb-3">Recovery Van (Non-flat-bed)</h6>
                                                </div>
                                            </div>
                                        )}

                                            {(selectedVehicleData.length === 0 || selectedVehicleData.includes('recoveryVan')) && (
                                                <div>
                                                    <div
                                                        className={`flex flex-col items-center overflow-hidden rounded-2xl shadow-[20px_20px_20px_rgba(0,0,0,0.3)]  cursor-pointer  bg-white transition-shadow duration-300 hover:shadow-2xl ${selectedFlatbed ? 'ring-2 ring-yellow-400' : ''}`}
                                                        onClick={() => {
                                                            const newValue = !selectedFlatbed;

                                                            setSelectedFlatbed(newValue);
                                                            setSelectedNonFlatbed(false);
                                                            setSelectedCrane(false);
                                                            setSelectedBoth(false);

                                                        if (newValue) {
                                                            localStorage.setItem('vehicleType', 'recoveryVan');
                                                            localStorage.setItem('currentService', 'recoveryVan');
                                                            localStorage.setItem('flatbedOption', 'Flat-bed');
                                                            setVehicleType('recoveryVan');
                                                            setFlatOption('Flat-bed');
                                                        } else {
                                                            localStorage.removeItem('vehicleType');
                                                            localStorage.removeItem('currentService');
                                                            localStorage.removeItem('flatbedOption');
                                                            setVehicleType(null);
                                                            setFlatOption(null);
                                                            setFullAddress(null);
                                                        }
                                                    }}
                                                >
                                                    <div className="w-full aspect-[8/3] overflow-hidden">
                                                        <img
                                                            src={mediumFlatbedImage}
                                                            className="w-full h-full object-contain transition-transform duration-300 hover:scale-105"
                                                            alt="Flat-bed Recovery Van"
                                                        />
                                                    </div>
                                                    <h6 className="text-center font-satoshi text-sm md:text-base font-semibold mb-3">Recovery Van (Flat-bed)</h6>
                                                </div>
                                            </div>
                                        )}

                                            {(selectedVehicleData.length === 0 || (selectedVehicleData.includes('crane') && selectedVehicleData.includes('recoveryVan'))) && (
                                                <div>
                                                    <div hidden
                                                        className={`flex flex-col items-center overflow-hidden rounded-2xl shadow-[20px_20px_20px_rgba(0,0,0,0.3)] cursor-pointer transition-shadow duration-300  bg-[#FFFFFF] hover:shadow-2xl ${selectedBoth ? 'ring-2 ring-yellow-400' : ''}`}
                                                        onClick={() => {
                                                            const newValue = !selectedBoth;
                                                            if (newValue) {
                                                                localStorage.setItem('vehicleType', 'crane,recoveryVan');
                                                                setVehicleType('crane,recoveryVan');
                                                            } else {
                                                                localStorage.removeItem('vehicleType');
                                                                setVehicleType(null);
                                                            }

                                                            setSelectedBoth(newValue);
                                                            setSelectedCrane(false);
                                                            setSelectedRecoveryVan(false);
                                                        }}
                                                    >
                                                        <div className="w-full aspect-[8/3] flex overflow-hidden">
                                                            <img
                                                                src="https://cdn.leonardo.ai/users/ad8e5f61-d0b6-407e-b941-75e27c29b608/generations/20aa7104-dd5b-4c89-8013-c72c34624f43/segments/4:4:1/Flux_Dev_Create_a_realistic_detailed_image_of_a_yellow_hydra_c_3.jpg"
                                                                className="w-1/2 h-full object-contain object-bottom"
                                                                alt="Hydra Crane"
                                                            />
                                                            <img
                                                                src="https://cdn.leonardo.ai/users/ad8e5f61-d0b6-407e-b941-75e27c29b608/generations/5199123c-69de-42db-b3ed-714423a253c1/segments/4:4:1/Flux_Dev_Create_a_realistic_detailed_image_of_a_yellow_recover_3.jpg"
                                                                className="w-1/2 h-full object-contain object-bottom"
                                                                alt="Recovery Truck"
                                                            />
                                                        </div>
                                                        <h6 className="text-center font-satoshi text-sm md:text-base font-semibold my-3">
                                                            Recovery + Hydra Crane
                                                        </h6>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <ModalForQuantity
                                        isOpen={isModalOpenQuantity}
                                        onClose={() => setIsModalOpenQuantity(false)}
                                        quantity={quantity}
                                        setQuantity={setQuantity}
                                        getVendorsWithLocation={getVendorsWithLocation}
                                        setCurrentStep={setCurrentStep}
                                    />

                                    <ModalForFlatBed
                                        isOpen={isModalFlatBed}
                                        onClose={() => setIsModalFlatBed(false)}
                                        setFlatOption={setFlatOption}
                                        flatOption={flatOption}
                                        setCurrentStep={setCurrentStep}
                                        getVendorsWithLocationForFlatBed={getVendorsWithLocationForFlatBed}
                                    />

                                    <ModalForQuantityAndFlatBed
                                        isOpen={isModalQuantityFlatBed}
                                        onClose={() => setIsModalQuantityFlatBed(false)}
                                        quantity={quantity}
                                        setQuantity={setQuantity}
                                        getVendorsWithLocation={getVendorsWithLocation}
                                        setFlatOption={setFlatOption}
                                        getVendorsWithLocationForFlatBed={getVendorsWithLocationForFlatBed}
                                        setCurrentStep={setCurrentStep}
                                    />
                                </div>
                                <div className="flex font-satoshi justify-center fixed bottom-0 left-0 right-0 z-[9999] ">
                                    <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                        <button
                                            onClick={() => { localStorage.setItem('currentStep', '02'); setCurrentStep('02') }}
                                            className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                    >
                                        <img src={rightArrow} alt="Continue" className="h-[24px] w-[24px] rotate-180" />
                                        Back
                                    </button>
                                    <button
                                        disabled={vehicleType == null}
                                        onClick={handleChooseVehicleContinue}
                                        className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full ${vehicleType !== null
                                            ? "bg-[#21A6E9] hover:bg-[#1e94d6]"
                                            : "bg-[#a7dbf5] cursor-not-allowed"
                                            }`}
                                    >
                                        Continue
                                        <img src={rightArrow} alt="Back" className="h-[24px] w-[24px]" />
                                    </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    )}


                    {currentStep === '04' && (
                        <div className='h-[100vh] bg-white pt-[3rem]'>
                            <TestMapLoader
                                setCurrentStep={setLoaderStage}
                                incomingAccidentCode={incomingAccidentCode}
                                isLoading={isLoading}
                                setChooseFromSelectedServiceFinal={setChooseFromSelectedServiceFinal}
                                chooseFromSelectedServiceFinal={chooseFromSelectedServiceFinal}
                                pickupLocation={pickupLocation}
                                setPickupLocation={setPickupLocation}
                                dropLocation={dropLocation}
                                setDropLocation={setDropLocation}
                                stats={stats}
                                setVehicleType={setVehicleType}
                                vehicleType={vehicleType}
                                handleSubmit={handleSubmit}
                                isModalWaitingProp={isModalWaiting}
                                setIsModalWaiting={setIsModalWaiting}
                                vendorData={vendorData}
                                setAccidentDataObject={setAccidentDataObject}
                                quantity={quantity}
                                chooseFromSelectedSubServiceFinal={localStorage.getItem('flatbedOption')}
                                unloadWeight={unloadWeight}
                            />
                        </div>
                    )}

                    {currentStep === '05' && (
                        <div >
                            <div className="h-screen bg-gray-100">
                                <ContactingServiceCard
                                    isLoading={true}
                                    setIsLoading={setIsLoading}
                                    getVendorsWithLocation={getVendorsWithLocation}
                                    getVendorsWithLocationForFlatBed={getVendorsWithLocationForFlatBed}
                                    setChooseFromSelectedServiceFinal={setChooseFromSelectedServiceFinal}
                                    setCurrentStep={setCurrentStep}
                                    currentService={vehicleType}
                                    chooseFromSelectedServiceFinal={chooseFromSelectedServiceFinal}
                                    incomingAccidentVehicleCode={accidentVehicleCode}
                                    trackRepeatedRequests={trackRepeatedRequests}
                                    minEstimatedDuration={minEstimatedDuration}
                                    maxEstimatedDuration={maxEstimatedDuration}
                                    minEstimatedAmount={minEstimatedAmount}
                                    maxEstimatedAmount={maxEstimatedAmount}
                                    stats={stats}
                                    handleSubmit={handleSubmit}
                                />
                            </div>
                        </div>
                    )}

                </div >
            </div>

        </>
    )
}

export default AddVehicles;


function ModalForQuantity({ isOpen, onClose, quantity, setQuantity, getVendorsWithLocation, setCurrentStep }) {
    const [inputValue, setInputValue] = useState('');
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div className="bg-white py-[42px] px-[50px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                <div class="form-check ">
                    <label className="form-check-label" htmlFor="flexCheckDefault">
                    </label>
                </div>

                <h6 className=" font-[500] text-[20px] font-satoshi  text-[#000000]">Enter loaded weight of the Material (in Tons)
                </h6>
                <input
                    type="number"
                    min="0"
                    placeholder="Enter loaded weight"
                    className="mt-5 text-lg w-full text-center focus:outline-none focus:ring-2 focus:ring-[#21A6E9] rounded-[20px] border border-gray-300"
                    value={inputValue}
                    onChange={(e) => {
                        let val = e.target.value;
                        val = val.replace(/\D/g, '').replace(/^0+/, '');
                        setInputValue(val);
                        if (val) {
                            setQuantity(val + '000');
                        } else {
                            setQuantity('');
                        }
                    }}
                    autoFocus
                    maxLength={5}
                />

                <div className={`grid ${quantity ? 'grid-cols-1' : 'grid-cols-2'}  md: pt-[40px] items-center gap-[18px]`}>
                    {!quantity && (
                        <div
                            onClick={() => {
                                getVendorsWithLocation(); setCurrentStep('04')
                                onClose();
                            }}
                            className={`bg-[#EE3840] flex py-[5px] rounded-full pr-[0.5rem] pl-[1rem] w-full justify-between items-center cursor-pointer whitespace-nowrap`}>
                            <button className="font-satoshi font-[400] text-[13px] leading-[33.6px] pr-[0.3rem] text-[#FFFFFF]">Empty</button>
                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[1rem] w-[1rem]' alt="" />
                        </div>
                    )}

                    <div
                        onClick={() => {
                            if (quantity) {
                                getVendorsWithLocation();
                                setCurrentStep('04');
                                onClose();
                            }
                        }}
                        className={`flex py-[5px] rounded-full pr-[0.5rem] pl-[1rem] w-full cursor-pointer justify-between items-center 
              ${quantity ? 'bg-[#21A6E9] hover:bg-[#1e94d6]' : 'bg-gray-400 cursor-not-allowed'}`}>
                        <button
                            className="font-satoshi font-[400] text-[13px] leading-[33.6px] text-[#FFFFFF]"
                            disabled={!quantity}
                        >
                            Continue
                        </button>
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className="h-[1rem] w-[1rem]" alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};


function ModalLast({ isOpen, onClose, }) {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div className="bg-white py-[42px] px-[50px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute top-1 right-2 bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-700"
                >
                    ❌
                </button>
                <div className="flex gap-2 items-center justify-center">
                    <ClipLoader size={20} color="#ffffff" />
                    <span className='flex gap-2 items-center justify-center"'>Searching For Vendors...</span>
                </div>
                <h6 className="m-0 font-[500] text-[18px] font-satoshi text-center text-[#000000]">Connecting to Vendors wait for 3 minutes </h6>
                <div
                    onClick={onClose}
                    className="bg-[#EE3840] flex py-[5px] mt-5 rounded-full pr-[6px] pl-[26px] w-full justify-between items-center cursor-pointer">
                    <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[36px] text-[#FFFFFF]">Waiting...</button>
                </div>
            </div>
        </div>
    );
};

function ModalForFlatBed({ isOpen, onClose, setFlatOption, setCurrentStep, getVendorsWithLocationForFlatBed }) {
    const [selectedFilter, setSelectedFilter] = useState(null);

    const modalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen,]);

    useEffect(() => {
        if (selectedFilter === 'a') {
            setFlatOption('Flat-bed');
        }
        if (selectedFilter === 'b') {
            setFlatOption('Non-flat-bed');
        }
    }, [selectedFilter])

    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div ref={modalRef} className="bg-white py-[42px] px-[1rem] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                <h6 className=" font-[500] text-[20px] font-satoshi text-center text-[#000000]">Select Recovery Van Type
                </h6>

                <div className="flex justify-center my-4 gap-4">
                    <div
                        onClick={() => {
                            setSelectedFilter('a');
                            localStorage.setItem('flatbedOption', 'Flat-bed');
                            getVendorsWithLocationForFlatBed();
                            setCurrentStep('04');
                            onClose();
                        }}
                        className={`px-4 py-2 rounded-lg border text-sm font-semibold cursor-pointer ${selectedFilter === 'a'
                            ? 'bg-white text-gray-700 border-gray-300'
                            : 'bg-blue-600 text-white border-blue-600'
                            }`}
                    >
                        Flatbed
                    </div>

                    <div
                        onClick={() => {
                            setSelectedFilter('b');
                            localStorage.setItem('flatbedOption', 'Non-flat-bed');
                            getVendorsWithLocationForFlatBed();
                            setCurrentStep('04');
                            onClose();
                        }}
                        className={`px-4 py-2 rounded-lg border text-sm font-semibold cursor-pointer ${selectedFilter === 'b'
                            ? 'bg-white text-gray-700 border-gray-300'
                            : 'bg-red-300 text-gray-800 border-red-600'
                            }`}
                    >
                        Non-flatbed
                    </div>
                </div>
            </div>
        </div>
    );
};


function ModalForQuantityAndFlatBed({
    isOpen,
    onClose,
    quantity,
    setQuantity,
    getVendorsWithLocation,
    setFlatOption,
    getVendorsWithLocationForFlatBed,
    setCurrentStep,
}) {
    const [selectedFilter, setSelectedFilter] = useState(null);
    const modalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    useEffect(() => {
        if (selectedFilter === 'a') {
            setFlatOption('Flat-bed');
            localStorage.setItem('flatbedOption', 'Flat-bed');
            getVendorsWithLocationForFlatBed();
        } else if (selectedFilter === 'b') {
            setFlatOption('Non-flat-bed');
            localStorage.setItem('flatbedOption', 'Non-flat-bed');
            getVendorsWithLocationForFlatBed();
        }
    }, [selectedFilter]);

    const handleContinue = () => {
        if (quantity && selectedFilter) {
            getVendorsWithLocation();
            setCurrentStep('04');
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div ref={modalRef} className="bg-white py-[42px] px-[1rem] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                <h6 className="font-[500] text-[20px] font-satoshi text-center text-[#000000]">
                    Enter loaded weight of the Material (in Tons)
                </h6>

                <input
                    type="number"
                    min="0"
                    placeholder="Enter loaded weight"
                    className="mt-5 text-lg w-full text-center focus:outline-none focus:ring-2 focus:ring-[#21A6E9] rounded-[20px] border border-gray-300"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                    autoFocus
                    maxLength={5}
                />

                <h6 className="mt-6 font-[500] text-[20px] font-satoshi text-center text-[#000000]">
                    Select Recovery Van Type
                </h6>

                <div className="flex justify-center my-4 gap-4">
                    <div
                        onClick={() => setSelectedFilter('a')}
                        className={`px-4 py-2 rounded-lg border text-sm font-semibold cursor-pointer ${selectedFilter === 'a'
                            ? 'bg-white text-gray-700 border-gray-300'
                            : 'bg-blue-600 text-white border-blue-600'
                            }`}
                    >
                        Flatbed
                    </div>

                    <div
                        onClick={() => setSelectedFilter('b')}
                        className={`px-4 py-2 rounded-lg border text-sm font-semibold cursor-pointer ${selectedFilter === 'b'
                            ? 'bg-white text-gray-700 border-gray-300'
                            : 'bg-red-300 text-gray-800 border-red-600'
                            }`}
                    >
                        Non-flatbed
                    </div>
                </div>

                <div className="grid pt-[20px] items-center gap-[18px]">
                    <div
                        onClick={handleContinue}
                        className={`flex py-[5px] rounded-full pr-[0.5rem] pl-[1rem] w-full cursor-pointer justify-between items-center 
              ${quantity && selectedFilter ? 'bg-[#21A6E9] hover:bg-[#1e94d6]' : 'bg-gray-400 cursor-not-allowed'}`}
                    >
                        <button
                            className="font-satoshi font-[400] text-[13px] leading-[33.6px] text-[#FFFFFF]"
                            disabled={!quantity || !selectedFilter}
                        >
                            Continue
                        </button>
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className="h-[1rem] w-[1rem]" alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
}